<form [formGroup]="sbBerekeningFg">
    <div class="row">
        <div class="col col-1 bold">
            Verschuldigde schenkbelasting
        </div>
        <div class="col-2 bold">

        </div>
        <div class="col-2 bold">

        </div>
    </div>
    <div class="row pt-1">
        <div class="col col-1">
            <p>Belaste schenking</p>
        </div>
        <div class="col-2">

        </div>
        <div class="col-3">
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150 custom-readonly"
                                              formControlName="totaleBelastbareSchenking"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-4"></div>
    </div>

    <div class="row">
        <div class="col col-1">
            <p>Belasting ({{ this.percentageEersteSchijf }}%) over de eerste schijf ad
                € {{ this.lengteEersteSchijf }}</p>
        </div>
        <div class="col-2">
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150 custom-readonly"
                                              formControlName="belastingEersteSchijf"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
    </div>
    <div *ngIf="this.sbBerekening.verhogingEersteSchijfVanwegeBrutering !== undefined" class="row">
        <div class="col col-1">
            <p>Brutering belasting eerste schijf</p>
        </div>
        <div class="col-2">
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150 custom-readonly"
                                              formControlName="verhogingEersteSchijfVanwegeBrutering"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
    </div>

    <div *ngIf="this.sbBerekening.belastingTweedeSchijf !== undefined" class="row">
        <div class="col col-1">
            <p>Belasting ({{ this.percentageTweedeSchijf }}%) over de tweede schijf ad
                € {{ this.lengteTweedeSchijf }}</p>
        </div>
        <div class="col-2">
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150 custom-readonly"
                                              formControlName="belastingTweedeSchijf"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
    </div>

    <div *ngIf="this.sbBerekening.verhogingTweedeSchijfVanwegeBrutering !== undefined" class="row">
        <div class="col col-1">
            <p>Brutering belasting tweede schijf</p>
        </div>
        <div class="col-2">
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150 custom-readonly"
                                              formControlName="verhogingTweedeSchijfVanwegeBrutering"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
    </div>
    <div *ngIf="this.sbBerekening.bedragConserverendeAanslag !== undefined" class="row">
        <div class="col col-1">
            <p>Af: verschuldigd op conserverende aanslag</p>
        </div>
        <div class="col-2">
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150 custom-readonly"
                                              formControlName="bedragConserverendeAanslag"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
    </div>
    <div class="row">
        <div class="col col-1">
            <p>Totaal berekende schenkbelasting</p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150 custom-readonly"
                                              formControlName="verschuldigdeSchenkbelasting"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-4"></div>
    </div>
    <div *ngIf="this.hasOnroerendeZaken" class="row">
        <div class="col col-1">
            <p>Af: te verrekenen overdrachtsbelasting</p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150 custom-readonly"
                                              formControlName="verrekeningOverdrachtsBelasting"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-4"></div>
    </div>
    <div *ngIf="this.sbBerekening.voorkomingDubbeleBelasting !== undefined" class="row">
        <div class="col col-1">
            <p>Af: voorkoming dubbele belasting</p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150 custom-readonly"
                                              formControlName="voorkomingDubbeleBelasting"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-4"></div>
    </div>
    <div class="row">
        <div class="col col-1">
            <p *ngIf="this.sbAangifte.schenking ? this.sbAangifte.schenking[0]?.schenkerBetaaltDeSchenkbelasting : false">
                Te betalen schenkbelasting (door de schenker)</p>
            <p *ngIf="this.sbAangifte.schenking ? !this.sbAangifte.schenking[0]?.schenkerBetaaltDeSchenkbelasting : true">
                Te betalen schenkbelasting (door de ontvanger)</p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150 custom-readonly"
                                              formControlName="teBetalenSchenkbelasting"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-4"></div>
    </div>
</form>

<div *ngIf="this.aantalValidatiesValue !== 0 && this.aantalValidatiesValue !== 451" style="width: 75%">
    <snelstart-ui-alert class="pb-2 pt-2 ps-2 pe-2" type="warning">
        Er zijn nog validatiemeldingen. <b></b> Klik op de button 'Validaties' in het menu en bekijk om
        welke validaties het gaat.<br/>
        Pas dan de gegevens aan zodat alle validatiemeldingen verdwijnen. Daarna wordt hier de belasting getoond.
    </snelstart-ui-alert>
</div>
